import VisualEditorComponentContainer from '..';

interface VisualEditorWrapperProps {
  /**
   * The action to perform on the component.
   */
  action?: any;
  /**
   * The storage type of the component.
   */
  storage?: any;
  /**
   * The UUID of the component.
   */
  uuid: string;
  /**
   * The children of the component.
   */
  children: React.ReactNode;
}

export default function VisualEditorWrapper({
  action = 'edit',
  storage = 'paragraph',
  uuid,
  children,
}: VisualEditorWrapperProps) {
  return (
    <VisualEditorComponentContainer
      action={action}
      storage={storage}
      uuid={uuid}
    >
      {children}
    </VisualEditorComponentContainer>
  );
}
